import React, { Component } from 'react'

import styled from 'styled-components'
import Helmet from 'react-helmet'
import LocationNav from '../components/NavPills/LocationNav'
import LocalAtm from '@material-ui/icons/LocalAtm'
import StoreMallDirectory from '@material-ui/icons/StoreMallDirectory'
import { navigateTo } from 'gatsby-link'

class LocationsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: this.getActiveTab(this.props.location.hash),
    }
  }
  getActiveTab = hash => {
    switch (hash) {
      case '#catm':
        return 0
      case '#branches':
        return 1
      default:
        return 0
    }
  }
  switchTabHash = hash => {
    navigateTo(hash)
  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)

    this.setState({ activeTab: this.getActiveTab(nextProps.location.hash) })
  }
  render() {
    const pageEdges = this.props.data.page.edges[0]
    const pageData = pageEdges.node.frontmatter
    const branchData = this.props.data.otc.edges[0].node.frontmatter
    const catmData = this.props.data.catm.edges[0].node.frontmatter

    return (
      <div>
        <Helmet title={pageData.title} />
        <TitleContainer>
          <h2>{pageData.title}</h2>
          <h5>
            <strong style={{ color: 'black' }}>{pageData.subtitle}</strong>
          </h5>
        </TitleContainer>
        <LocationsContainer>
          <LocationNav
            active={this.state.activeTab}
            onClick={prop =>
              this.switchTabHash(`#${prop.tabButton.toLowerCase()}`)
            }
            color="primary"
            tabs={[
              {
                tabButton: 'CATM',
                tabIcon: () => <LocalAtm />,
                mapContent: catmData,
                infoContent: pageData.catm,
              },
              {
                tabButton: 'Branches',
                tabIcon: () => <StoreMallDirectory />,
                mapContent: branchData,
                infoContent: pageData.branches,
              },
            ]}
          />
        </LocationsContainer>
      </div>
    )
  }
}

const TitleContainer = styled.div`
  margin: ${p => p.theme.col(2)} ${p => p.theme.col(2)} 0;

  @media screen and (max-width: 768px) {
    margin-top: 100px;
  }
`

const LocationsContainer = styled.div`
  padding: ${p => p.theme.col()} ${p => p.theme.col(4)} ${p => p.theme.col(2)};

  @media screen and (max-width: 768px) {
    padding: 25px ${p => p.theme.col(2)};
  }
`

const SectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 ${p => p.theme.col()};

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 50px 0;
  }
`

const LocationContainer = styled.div`
  padding: ${p => p.theme.col()} 0;
  display: inline-grid;
  max-width: 650px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 50px 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 50px 0;
  }
`

export const locationsQuery = graphql`
  query locationsQuery {
    page: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "locations-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            catm
            branches
          }
        }
      }
    }
    otc: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "otc-location-data" } } }
    ) {
      edges {
        node {
          frontmatter {
            defaultZoom
            mapCenter {
              lat
              lng
            }
            places {
              title
              address
              appointmentBooking
              location {
                lat
                lng
                city
                state
                country
                postal_code
              }
            }
          }
        }
      }
    }
    catm: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "catm-location-data" } } }
    ) {
      edges {
        node {
          frontmatter {
            defaultZoom
            mapCenter {
              lat
              lng
            }
            places {
              title
              address
              location {
                lat
                lng
                city
                state
                country
                postal_code
              }
            }
          }
        }
      }
    }
  }
`

export default LocationsPage



// WEBPACK FOOTER //
// ./src/pages/locations.jsx